import * as React from 'react';
import * as classNames from 'classnames';
import { DataTestObject, buildDataTest, renderDataTest } from '../../../utilities/testAutomation';

interface DateInputProps {
  error?: string | false;
  onChange: (e: React.ChangeEvent<any>) => void;
  onBlur: (e: React.FocusEvent<any>) => void;
  name: string;
  dataTest?: DataTestObject;
}

interface DateInputState {
  DD: DateField;
  MM: DateField;
  YYYY: DateField;
}

interface DateField {
  value: string;
  blurred: boolean;
}

class DateInput extends React.Component<DateInputProps, DateInputState> {
  constructor(props: DateInputProps) {
    super(props);
    this.state = {
      DD: { value: '', blurred: false },
      MM: { value: '', blurred: false },
      YYYY: { value: '', blurred: false },
    };
  }

  formatDate = (field: string, previous: string[], value: string) => {
    switch (field) {
      case 'DD':
        return previous[0] && previous[1] && `${previous[0] || '—'}/${previous[1] || '—'}/${value || '—'}`;
      case 'MM':
        return previous[0] && previous[2] && `${previous[0] || '—'}/${value || '—'}/${previous[2] || '—'}`;
      case 'YYYY':
        return previous[1] && previous[2] && `${value || '—'}/${previous[1] || '—'}/${previous[2] || '—'}`;
      default:
        return '';
    }
  }

  render() {
    const {
      error,
      onChange,
      onBlur,
      name,
      dataTest,
    } = this.props;
    const { DD, MM, YYYY } = this.state;
    const values = [YYYY.value, MM.value, DD.value];
    const shouldBlur = [DD.blurred, MM.blurred, YYYY.blurred].filter(blur => blur).length > 1;
    const errorDataTest = dataTest && renderDataTest(dataTest.isTesting)(`${dataTest.tag}-error`);

    return (
      <div className={classNames('input-wrapper', { 'has-error': !!error })}>
        <div className="input date-input">
          <div className="date-input-wrapper">
            {['DD', 'MM', 'YYYY'].map((field: string) => (
              <input
                type="text"
                key={field}
                name={name}
                placeholder={field}
                value={this.state[field].value}
                maxLength={field === 'YYYY' ? 4 : 2}
                onBlur={(e: React.FocusEvent<any>) => {
                  this.setState(
                    {
                      ...this.state,
                      [field]: {
                        ...this.state[field],
                        blurred: true,
                      },
                    }
                  );
                  if (shouldBlur) { onBlur(e); }
                }}
                onChange={(e: React.ChangeEvent<any>) => {
                  const { value } = e.target;
                  this.setState(
                    {
                      ...this.state,
                      [field]: {
                        ...this.state[field],
                        value,
                      },
                    }
                  );
                  e.target.value = this.formatDate(field, values, value);
                  onChange(e);
                }}
                {...buildDataTest(dataTest, field)}
              />
            ))}
          </div>
          <div className="error-text" {...errorDataTest}>{error}</div>
        </div>
      </div>
    );
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/DateInput/DateInput.tsx